import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SuggestLocationURL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdzRj7OcT_tF8BfjZcHHUHs3bM84BkQiL0gW2l51dgBCBw0lA/viewform';

const SuggestLocation = () => {
  const { t } = useTranslation('app');

  return (
    <div className="h-[88px] sm:h-[56px] bg-gray_light_1 flex flex-col sm:flex-row sm:items-center p-2x gap-x sm:gap-0.5x">
      <p className="text-gray__dark_2 text-body_2">
        {t('missingPropertyLocation')}
      </p>
      <Link
        to={SuggestLocationURL}
        target="_blank"
        className="text-link text-blue"
      >
        {t('newLocationRequest')}
      </Link>
    </div>
  );
};

export default SuggestLocation;
